import type { ReactNode } from "react";
import { LOCALES } from "../../schema/core.ts";
import { useSiteCopy } from "../i18n/useSiteCopy.ts";
import { useCourseKit } from "../provider.tsx";
import { cn } from "../ui/cn.ts";

/** One button that flips NL ⇄ EN; both codes are shown, the active one lit. */
export const LanguageToggle = (): ReactNode => {
  const { locale, setLocale } = useCourseKit();
  const copy = useSiteCopy().header;
  const next = LOCALES.find((candidate) => candidate !== locale) ?? locale;

  return (
    <button
      type="button"
      aria-label={copy.switchLanguage}
      lang={next}
      onClick={() => setLocale(next)}
      className={cn(
        "inline-flex min-h-11 items-center gap-0.5 rounded-full border",
        "border-header-foreground/35 p-0.5 font-mono text-base tracking-widest transition-colors",
        "hover:border-highlight",
      )}>
      {LOCALES.map((code) => (
        <span
          key={code}
          aria-hidden="true"
          className={cn(
            "grid h-8 min-w-8.5 place-items-center rounded-full px-1",
            code === locale ? "bg-header-foreground text-header" : "text-header-foreground/80",
          )}>
          {code.toUpperCase()}
        </span>
      ))}
    </button>
  );
};
